import Navbar from '../components/Navbar';
import Footer from 'components/Footer';
import { useSelector } from "react-redux";
import MobileNavbar from 'components/MobileNavbar';
import MobileFooter from 'components/MobileFooter';


import HomePage from 'components/BKantarciHome/HomePage';
import { useEffect } from "react";

function Home() {

    const isMobile = useSelector(state => state.windowSize.isMobile);

    useEffect(() => {
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    }, []);
  
    return (
      <>
      {isMobile ? ( 
        <>
          <MobileNavbar />
          <HomePage />
          <MobileFooter />
        </>
      ) : (
        <>
          <Navbar />
          <HomePage />
          <Footer />
        </>
      )}
      </>
    );
  }
  
  export default Home;


  /*
  
  return (
      <>
      {isMobile ? ( 
        <>
          <MobileNavbar />
          <Header />
          <hr />
          <DirectorMobile />
          <hr />
          <BodyMobile />
          <hr />
          <MobileFooter />
        </>
      ) : (
        <>
          <Navbar />
          <Header />
          <hr />
          <Director />
          <hr />
          <Body />
          <hr />
          <Footer />
        </>
      )}
      </>
    );

  */